<mat-card class="slidecontent">
  <div class="headcontent">
    <div class="pophead">
      <h3>Apply Filter</h3>
      <button mat-icon-button>
        <mat-icon class="close" (click)="closeFilterSilde(false)">close</mat-icon>
      </button>
    </div>

  </div>
  <div class="dialog_content">


    <form [formGroup]="myFormGroup">

      <div class="" fxLayout="column" fxlayoutAlign="center" *ngFor="let field of defaultFilterFieldsList">
        <div class="fullw" [ngSwitch]="field.fieldTypeName">

          <ng-container *ngSwitchCase="'Textbox'">
            <mat-form-field *ngIf="field.fieldName != 'Address'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <input matInput
                (input)="onSearchChange($event.target.value,field.fieldName,field.fieldID,field.fieldTypeID,0)"
                [(ngModel)]="field.defaultValue" placeholder=" {{ field.placeholder }}"
                formControlName="{{ field.fieldName }}" />
            </mat-form-field>

          </ng-container>

          <ng-container *ngSwitchCase="'State'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input matInput
                (input)="onSearchChange($event.target.value,field.fieldName,field.fieldID,field.fieldTypeID,2)"
                [(ngModel)]="field.defaultValue" placeholder=" {{ field.placeholder }}"
                formControlName="{{ field.fieldName }}" />
            </mat-form-field>
          </ng-container> 

          <ng-container *ngSwitchCase="'City'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input matInput
                (input)="onSearchChange($event.target.value,field.fieldName,field.fieldID,field.fieldTypeID,3)"
                [(ngModel)]="field.defaultValue" placeholder=" {{ field.placeholder }}"
                formControlName="{{ field.fieldName }}" />
            </mat-form-field>
          </ng-container>

          <!-- <ng-container *ngSwitchCase="'State'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-chip-list #chipList aria-label="State selection">
                <mat-chip *ngFor="let state of states" [selectable]="selectable" [removable]="removable"
                  (removed)="removeState(state,field.fieldName,field.fieldID,field.fieldTypeID,2)">
                  {{state}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input placeholder="Add States" #stateInput [formControl]="stateCtrl" [matAutocomplete]="auto"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  >
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete"
                (optionSelected)="selectedState($event,field.fieldName,field.fieldID,field.fieldTypeID,2)">
                <mat-option *ngFor="let state of filteredStates | async" [value]="state">
                  {{state}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </ng-container> -->


          <!-- <ng-container *ngSwitchCase="'City'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-chip-list #chipList aria-label="City selection">
                <mat-chip *ngFor="let city of citys" [selectable]="selectable" [removable]="removable"
                  (removed)="removeCity(city,field.fieldName,field.fieldID,field.fieldTypeID,3)">
                  {{city}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input placeholder="Add City" #cityInput [formControl]="cityCtrl" [matAutocomplete]="auto"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  >
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete"
                (optionSelected)="selectedCity($event,field.fieldName,field.fieldID,field.fieldTypeID,3); ">
                <mat-option *ngFor="let city of filteredCitys | async" [value]="city">
                  {{city}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </ng-container> -->

          <ng-container *ngSwitchCase="'ZipCode'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-chip-list #chipList aria-label="ZipCode selection">
                <mat-chip *ngFor="let zipcode of zipcodes" [selectable]="selectable" [removable]="removable"
                  (removed)="removeZipCode(zipcode,field.fieldName,field.fieldID,field.fieldTypeID,4)">
                  {{zipcode}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input placeholder="Add Zip code" #zipcodeInput [formControl]="zipcodeCtrl" [matAutocomplete]="auto"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  >
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete"
                (optionSelected)="selectedZipCode($event,field.fieldName,field.fieldID,field.fieldTypeID,4)">
                <mat-option *ngFor="let zipcode of filteredZipcodes | async" [value]="zipcode">
                  {{zipcode}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </ng-container>


          <ng-container *ngSwitchCase="'Textarea'">
            <mat-form-field>
              <mat-label>{{ field.fieldName }}</mat-label>
              <input matInput
                (input)="onSearchChange($event.target.value,field.fieldName,field.fieldID,field.fieldTypeID,0)"
                placeholder="{{ field.placeholder }}" formControlName="{{ field.fieldName }}" />
            </mat-form-field>
          </ng-container>


          <ng-container *ngSwitchCase="'Date'">
            <!-- <mat-label >{{ field.fieldName }}</mat-label>
              <ngx-mat-drp  (selectedDateRangeChanged)="updateRange($event)" placeholder="Choose date"
              [options]="options" #dateRangePicker></ngx-mat-drp> -->
            <!-- [(ngModel)]="selected" -->

            <!-- <mat-label *ngIf="field.label != ''">{{field.label}}</mat-label> -->
            <!-- <Input *ngIf="field.label != ''" type="text" matInput value="{{field.label}}" disabled> -->
              <div class="prelative">
                <ng-container *ngIf="fieldlabelShow"> 
                <span *ngIf="field.label != '' "  class="datelabel" >{{field.label}}</span>   
              </ng-container>            
              <div *ngIf="field.fieldName=='Date Added' || field.fieldName=='Last Touch'">
                <mat-form-field>
                  <mat-label>{{ field.fieldName }}</mat-label>
                  <input matInput ngxDaterangepickerMd formControlName="{{ field.fieldName }}" 
                     placeholder="Select Date Range" [showCustomRangeLabel]="true" [maxDate]="maxDate"
                    [alwaysShowCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCancel]="true"
                    [linkedCalendars]="false" [locale]="{ applyLabel: 'Done' }" [keepCalendarOpeningWithRange]="true"
                    [showRangeLabelOnInput]="false" (rangeClicked)="rangeClicked($event, field.fieldName)"
                    (datesUpdated)="datesUpdated($event,field.fieldName,field.fieldID,field.fieldTypeID)" />
                </mat-form-field>
               </div>
               <div *ngIf="field.fieldName=='Next Touch'">
                <mat-form-field>
                  <mat-label>{{ field.fieldName }}</mat-label>
                  <input matInput ngxDaterangepickerMd formControlName="{{ field.fieldName }}" 
                     placeholder="Select Date Range" [showCustomRangeLabel]="true" [minDate]="minDate"
                    [alwaysShowCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCancel]="true"
                    [linkedCalendars]="false" [locale]="{ applyLabel: 'Done' }" [keepCalendarOpeningWithRange]="true"
                    [showRangeLabelOnInput]="false" (rangeClicked)="rangeClicked($event, field.fieldName)"
                    (datesUpdated)="datesUpdated($event,field.fieldName,field.fieldID,field.fieldTypeID)" />
                </mat-form-field>
               </div>
              </div>
            
          </ng-container>



          <ng-container *ngSwitchCase="'Dropdown'">

            <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Importance'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-chip-list #chipList aria-label="Importance selection">
                <mat-chip *ngFor="let importance of importances " [selectable]="selectable" [removable]="removable"
                  (removed)="removeImportance(importance,field.fieldName,field.fieldID,field.fieldTypeID,0)">
                  {{importance}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input placeholder="Add Importances" #importanceInput [formControl]="importanceCtrl"
                  [matAutocomplete]="auto" [matChipInputFor]="chipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addImportance($event)">
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete"
                (optionSelected)="selectedImportance($event,field.fieldName,field.fieldID,field.fieldTypeID,0)">
                <mat-option *ngFor="let importance of filteredImportances | async" [value]="importance">
                  {{importance}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Type'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-chip-list #chipList aria-label="Type selection">
                <mat-chip *ngFor="let type of types" [selectable]="selectable" [removable]="removable"
                  (removed)="removeType(type,field.fieldName,field.fieldID,field.fieldTypeID,0)">
                  {{type}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input placeholder="Add Types" #typeInput [formControl]="typeCtrl" [matAutocomplete]="auto"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addType($event)">
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete"
                (optionSelected)="selectedType($event,field.fieldName,field.fieldID,field.fieldTypeID,0)">
                <mat-option *ngFor="let type of filteredTypes | async" [value]="type">
                  {{type}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

          </ng-container>

        

          <ng-container *ngSwitchCase="'MultiSelect'">

            <mat-form-field class="example-chip-list" *ngIf="field.fieldName == 'Tags'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-chip-list #chipList aria-label="Tag selection">
                <mat-chip *ngFor="let tag of tags" [selectable]="selectable" [removable]="removable"
                  (removed)="removeTags(tag,field.fieldName,field.fieldID,field.fieldTypeID,0)">
                  {{tag}}
                  <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                </mat-chip>
                <input placeholder="Add Tags" #tagInput [formControl]="tagCtrl" [matAutocomplete]="auto"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="addTags($event)">
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete"
                (optionSelected)="selectedTags($event,field.fieldName,field.fieldID,field.fieldTypeID,0)">
                <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
                  {{tag}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>



            <mat-form-field *ngIf="field.fieldName != 'Tags'">
              <mat-label>{{ field.fieldName }}</mat-label>
              <mat-select multiple formControlName="{{ field.fieldName }}">
                <mat-option *ngFor="let muldrp of getMuldropdownlist(field.fieldName)" [value]="muldrp">
                  {{ muldrp }}
                </mat-option>
              </mat-select>
            </mat-form-field>

          </ng-container>


        </div>
      </div>
    </form>

  </div>


  <div class="actionBtn" *ngIf="!saveFilterButtonDisabled">
    <button mat-stroked-button class="calltoaction" type="submit" (click)="clearFilterSilde(false)" color="basic"> Clear All </button>
    <button mat-flat-button class="calltoaction" type="submit" [disabled]="saveFilterButtonDisabled" (click)="openDialogWithRef(myDialog)" color="accent">Save</button>
  </div>


</mat-card>

<ng-template #myDialog>
  <h2 matDialogTitle>Add a new filter</h2>
  <mat-dialog-content>
    <mat-form-field class="example-full-width">
      <mat-label>Filter Name</mat-label>
      <input matInput maxlength="30" [(ngModel)]="filterName" (ngModelChange)="filters($event)" [ngModelOptions]="{ standalone: true }" 
      placeholder="Add Filter Name"
        value="" />
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button  color="" (click)="closefilter()">Close</button>
    <button mat-button [disabled]="!createFilterButton" (click)="createFilter()" color="primary">
      Create
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>
</ng-template>

<div class="overlay" (click)="closeFilterSilde(false)"></div>

<app-loader></app-loader>